'use strict';

var Base = require('front/components/Base/Base');

require('./IndexCredits.less');

module.exports = Base.extend({

    events: {
    },

    initialize: function (options) {
        this.options = options || {};


        app.vent.on('loaded', () => {
            this.headerAnimator = new app.utils.HeaderAnimator(this.$('h2'));
        });

        this.$('h2').onCustom('screen-enter', (e, data) => {
            this.headerAnimator.fire(app.settings.showDelay);
            this.headerAnimator = null;
            data.$el.offCustom('screen-enter');
        });


        this.$('.IndexCredits-text').onCustom('screen-enter', (e, data) => {
            data.$el.addClass('show');
            data.$el.offCustom('screen-enter');
        });

        this.$('.IndexCredits-item').onCustom('screen-enter', (e, data) => {
            data.$el.addClass('show');
            data.$el.offCustom('screen-enter');
        });

        Base.prototype.initialize.call(this, options);
    }

});
